import { render, staticRenderFns } from "./FerramentaCalculadoraForroPvc.vue?vue&type=template&id=6a7ac469&scoped=true"
import script from "./FerramentaCalculadoraForroPvc.vue?vue&type=script&lang=js"
export * from "./FerramentaCalculadoraForroPvc.vue?vue&type=script&lang=js"
import style0 from "./FerramentaCalculadoraForroPvc.vue?vue&type=style&index=0&id=6a7ac469&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7ac469",
  null
  
)

export default component.exports